import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="mailto"
export default class extends Controller {
  static values = {
    user: String,
    domain: String
  };

  connect() {
    this.element.href = 'mailto:' + this.userValue + '@' + this.domainValue;
  }
}
